var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupDecor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 176,
    viewBox: "0 0 532 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.997 55.8663C69.605 55.8663 1.1818 -6.48504 0.499512 -7.11507L1.3125 -8C1.9912 -7.37358 70.0787 54.6639 145.997 54.6639C221.923 54.6639 281.392 -0.820785 281.984 -1.38108L282.807 -0.508174C282.212 0.0569286 222.395 55.8663 145.997 55.8663Z",
    fill: "#47A5C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.018 16.4899C253.018 20.1426 255.971 23.1028 259.613 23.1028C263.254 23.1028 266.208 20.1426 266.208 16.4899C266.208 12.8371 263.254 9.87695 259.613 9.87695C255.971 9.87695 253.018 12.8371 253.018 16.4899Z",
    fill: "#47A5C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.268 48.7535C184.268 52.4063 187.221 55.3664 190.863 55.3664C194.506 55.3664 197.458 52.4063 197.458 48.7535C197.458 45.1008 194.506 42.1406 190.863 42.1406C187.221 42.1406 184.268 45.1008 184.268 48.7535Z",
    fill: "#47A5C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.712 54.5641C125.712 58.2168 128.665 61.177 132.307 61.177C135.95 61.177 138.903 58.2168 138.903 54.5641C138.903 50.9114 135.95 47.9512 132.307 47.9512C128.665 47.9512 125.712 50.9114 125.712 54.5641Z",
    fill: "#47A5C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3613 35.527C60.3613 39.1797 63.3135 42.1399 66.9564 42.1399C70.5993 42.1399 73.5515 39.1797 73.5515 35.527C73.5515 31.8742 70.5993 28.9141 66.9564 28.9141C63.3135 28.9141 60.3613 31.8742 60.3613 35.527Z",
    fill: "#47A5C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.226 25.808C242.226 27.9662 243.97 29.7156 246.123 29.7156C248.275 29.7156 250.02 27.9662 250.02 25.808C250.02 23.6498 248.275 21.9004 246.123 21.9004C243.97 21.9004 242.226 23.6498 242.226 25.808Z",
    fill: "#47A5C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.876 52.4604C172.876 54.6186 174.621 56.368 176.774 56.368C178.926 56.368 180.671 54.6186 180.671 52.4604C180.671 50.3021 178.926 48.5527 176.774 48.5527C174.621 48.5527 172.876 50.3021 172.876 52.4604Z",
    fill: "#47A5C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9326 48.8529C98.9326 51.0112 100.677 52.7606 102.83 52.7606C104.982 52.7606 106.727 51.0112 106.727 48.8529C106.727 46.6947 104.982 44.9453 102.83 44.9453C100.677 44.9453 98.9326 46.6947 98.9326 48.8529Z",
    fill: "#47A5C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.033 31.2182C232.033 33.3764 233.778 35.1258 235.93 35.1258C238.083 35.1258 239.827 33.3764 239.827 31.2182C239.827 29.06 238.083 27.3105 235.93 27.3105C233.778 27.3105 232.033 29.06 232.033 31.2182Z",
    fill: "#47A5C6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0425 45.1459C87.0425 47.3041 88.7872 49.0535 90.9396 49.0535C93.092 49.0535 94.8367 47.3041 94.8367 45.1459C94.8367 42.9877 93.092 41.2383 90.9396 41.2383C88.7872 41.2383 87.0425 42.9877 87.0425 45.1459Z",
    fill: "#47A5C6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0757 23.5033C40.0757 25.6615 41.8204 27.411 43.9728 27.411C46.1252 27.411 47.8699 25.6615 47.8699 23.5033C47.8699 21.3451 46.1252 19.5957 43.9728 19.5957C41.8204 19.5957 40.0757 21.3451 40.0757 23.5033Z",
    fill: "#47A5C6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6846 16.0893C28.6846 18.2475 30.4293 19.9969 32.5817 19.9969C34.734 19.9969 36.4787 18.2475 36.4787 16.0893C36.4787 13.9311 34.734 12.1816 32.5817 12.1816C30.4293 12.1816 28.6846 13.9311 28.6846 16.0893Z",
    fill: "#47A5C6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.442 37.5297C219.442 38.8583 220.517 39.9344 221.841 39.9344C223.166 39.9344 224.239 38.8583 224.239 37.5297C224.239 36.2011 223.166 35.125 221.841 35.125C220.517 35.125 219.442 36.2011 219.442 37.5297Z",
    fill: "#47A5C6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.051 43.2426C208.051 44.5712 209.126 45.6473 210.449 45.6473C211.774 45.6473 212.848 44.5712 212.848 43.2426C212.848 41.914 211.774 40.8379 210.449 40.8379C209.126 40.8379 208.051 41.914 208.051 43.2426Z",
    fill: "#47A5C6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.683 53.6625C164.683 54.9899 165.756 56.0672 167.081 56.0672C168.405 56.0672 169.48 54.9899 169.48 53.6625C169.48 52.3339 168.405 51.2578 167.081 51.2578C165.756 51.2578 164.683 52.3339 164.683 53.6625Z",
    fill: "#47A5C6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.901 55.2641C139.901 56.5927 140.976 57.6688 142.3 57.6688C143.625 57.6688 144.698 56.5927 144.698 55.2641C144.698 53.9367 143.625 52.8594 142.3 52.8594C140.976 52.8594 139.901 53.9367 139.901 55.2641Z",
    fill: "#47A5C6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.117 53.0609C119.117 54.3883 120.192 55.4656 121.515 55.4656C122.839 55.4656 123.914 54.3883 123.914 53.0609C123.914 51.7324 122.839 50.6562 121.515 50.6562C120.192 50.6562 119.117 51.7324 119.117 53.0609Z",
    fill: "#47A5C6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.523 51.6566C110.523 52.9852 111.598 54.0613 112.922 54.0613C114.247 54.0613 115.32 52.9852 115.32 51.6566C115.32 50.3293 114.247 49.252 112.922 49.252C111.598 49.252 110.523 50.3293 110.523 51.6566Z",
    fill: "#47A5C6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1675 30.2152C53.1675 31.5426 54.2407 32.6199 55.5657 32.6199C56.8895 32.6199 57.9639 31.5426 57.9639 30.2152C57.9639 28.8866 56.8895 27.8105 55.5657 27.8105C54.2407 27.8105 53.1675 28.8866 53.1675 30.2152Z",
    fill: "#47A5C6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5903 10.477C21.5903 11.8044 22.6647 12.8817 23.9885 12.8817C25.3135 12.8817 26.3867 11.8044 26.3867 10.477C26.3867 9.14957 25.3135 8.07227 23.9885 8.07227C22.6647 8.07227 21.5903 9.14957 21.5903 10.477Z",
    fill: "#47A5C6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.814 78.5505C245.247 78.5505 153.381 -5.1641 152.465 -6.01055L153.556 -7.19727C154.466 -6.35682 245.885 76.937 347.814 76.937C449.755 76.937 529.601 2.43955 530.395 1.68808L531.5 2.86037C530.702 3.61905 450.388 78.5505 347.814 78.5505Z",
    fill: "#FFD947"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.503 25.6828C491.503 30.5872 495.468 34.5622 500.358 34.5622C505.247 34.5622 509.212 30.5872 509.212 25.6828C509.212 20.7796 505.247 16.8047 500.358 16.8047C495.468 16.8047 491.503 20.7796 491.503 25.6828Z",
    fill: "#FFD947"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.198 69.0004C399.198 73.9036 403.163 77.8786 408.053 77.8786C412.943 77.8786 416.907 73.9036 416.907 69.0004C416.907 64.0961 412.943 60.1211 408.053 60.1211C403.163 60.1211 399.198 64.0961 399.198 69.0004Z",
    fill: "#FFD947"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.579 76.802C320.579 81.7063 324.543 85.6813 329.434 85.6813C334.326 85.6813 338.289 81.7063 338.289 76.802C338.289 71.8988 334.326 67.9238 329.434 67.9238C324.543 67.9238 320.579 71.8988 320.579 76.802Z",
    fill: "#FFD947"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.836 51.2426C232.836 56.1458 236.799 60.1207 241.691 60.1207C246.582 60.1207 250.546 56.1458 250.546 51.2426C250.546 46.3382 246.582 42.3633 241.691 42.3633C236.799 42.3633 232.836 46.3382 232.836 51.2426Z",
    fill: "#FFD947"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.013 38.1943C477.013 41.092 479.356 43.4401 482.246 43.4401C485.135 43.4401 487.479 41.092 487.479 38.1943C487.479 35.2967 485.135 32.9473 482.246 32.9473C479.356 32.9473 477.013 35.2967 477.013 38.1943Z",
    fill: "#FFD947"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.903 73.9763C383.903 76.874 386.246 79.2234 389.135 79.2234C392.025 79.2234 394.368 76.874 394.368 73.9763C394.368 71.0787 392.025 68.7305 389.135 68.7305C386.246 68.7305 383.903 71.0787 383.903 73.9763Z",
    fill: "#FFD947"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.624 69.1338C284.624 72.0314 286.967 74.3808 289.856 74.3808C292.746 74.3808 295.089 72.0314 295.089 69.1338C295.089 66.2361 292.746 63.8867 289.856 63.8867C286.967 63.8867 284.624 66.2361 284.624 69.1338Z",
    fill: "#FFD947"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.329 45.4568C463.329 48.3544 465.672 50.7038 468.56 50.7038C471.45 50.7038 473.794 48.3544 473.794 45.4568C473.794 42.5591 471.45 40.2109 468.56 40.2109C465.672 40.2109 463.329 42.5591 463.329 45.4568Z",
    fill: "#FFD947"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.66 64.1572C268.66 67.0549 271.003 69.403 273.891 69.403C276.781 69.403 279.124 67.0549 279.124 64.1572C279.124 61.2595 276.781 58.9102 273.891 58.9102C271.003 58.9102 268.66 61.2595 268.66 64.1572Z",
    fill: "#FFD947"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.601 35.0986C205.601 37.9963 207.944 40.3444 210.833 40.3444C213.722 40.3444 216.065 37.9963 216.065 35.0986C216.065 32.2009 213.722 29.8516 210.833 29.8516C207.944 29.8516 205.601 32.2009 205.601 35.0986Z",
    fill: "#FFD947"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.306 25.1455C190.306 28.0431 192.649 30.3913 195.538 30.3913C198.428 30.3913 200.771 28.0431 200.771 25.1455C200.771 22.2478 198.428 19.8984 195.538 19.8984C192.649 19.8984 190.306 22.2478 190.306 25.1455Z",
    fill: "#FFD947"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.424 53.9334C446.424 55.7165 447.866 57.1629 449.644 57.1629C451.422 57.1629 452.863 55.7165 452.863 53.9334C452.863 52.1503 451.422 50.7051 449.644 50.7051C447.866 50.7051 446.424 52.1503 446.424 53.9334Z",
    fill: "#FFD947"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.13 61.5994C431.13 63.3825 432.571 64.8289 434.351 64.8289C436.128 64.8289 437.569 63.3825 437.569 61.5994C437.569 59.8163 436.128 58.3711 434.351 58.3711C432.571 58.3711 431.13 59.8163 431.13 61.5994Z",
    fill: "#FFD947"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.902 75.5908C372.902 77.3739 374.344 78.8191 376.122 78.8191C377.9 78.8191 379.343 77.3739 379.343 75.5908C379.343 73.8078 377.9 72.3613 376.122 72.3613C374.344 72.3613 372.902 73.8078 372.902 75.5908Z",
    fill: "#FFD947"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.63 77.742C339.63 79.5251 341.074 80.9715 342.849 80.9715C344.629 80.9715 346.07 79.5251 346.07 77.742C346.07 75.9589 344.629 74.5137 342.849 74.5137C341.074 74.5137 339.63 75.9589 339.63 77.742Z",
    fill: "#FFD947"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.724 74.783C311.724 76.5661 313.165 78.0113 314.944 78.0113C316.722 78.0113 318.165 76.5661 318.165 74.783C318.165 72.9999 316.722 71.5547 314.944 71.5547C313.165 71.5547 311.724 72.9999 311.724 74.783Z",
    fill: "#FFD947"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.186 72.9002C300.186 74.6833 301.63 76.1285 303.406 76.1285C305.186 76.1285 306.626 74.6833 306.626 72.9002C306.626 71.1171 305.186 69.6719 303.406 69.6719C301.63 69.6719 300.186 71.1171 300.186 72.9002Z",
    fill: "#FFD947"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.178 44.1111C223.178 45.8942 224.618 47.3406 226.399 47.3406C228.174 47.3406 229.618 45.8942 229.618 44.1111C229.618 42.328 228.174 40.8828 226.399 40.8828C224.618 40.8828 223.178 42.328 223.178 44.1111Z",
    fill: "#FFD947"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.781 17.6104C180.781 19.3934 182.225 20.8387 184.002 20.8387C185.78 20.8387 187.222 19.3934 187.222 17.6104C187.222 15.8273 185.78 14.3809 184.002 14.3809C182.225 14.3809 180.781 15.8273 180.781 17.6104Z",
    fill: "#FFD947"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M363.266 0.0566406V98.0479",
    stroke: "#D28E5A",
    strokeWidth: 2.4
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.361 103.16C369.361 106.535 366.632 109.272 363.266 109.272C359.899 109.272 357.169 106.535 357.169 103.16C357.169 99.7842 359.899 97.0488 363.266 97.0488C366.632 97.0488 369.361 99.7842 369.361 103.16Z",
    stroke: "#D28E5A",
    strokeWidth: 2.4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.673 116.283H371.86V107.266H354.673V116.283Z",
    fill: "#E1E1E1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.843 144.337C394.843 161.824 380.704 176 363.266 176C345.826 176 331.688 161.824 331.688 144.337C331.688 126.853 345.826 112.676 363.266 112.676C380.704 112.676 394.843 126.853 394.843 144.337Z",
    fill: "#3E6AED"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.975 140.131H394.556C394.415 139.061 394.221 138.007 393.976 136.975H332.557C332.311 138.007 332.117 139.061 331.975 140.131Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.664 164.178H387.868C388.675 163.174 389.42 162.12 390.102 161.021H336.43C337.111 162.12 337.858 163.174 338.664 164.178Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.455 168.987H383.077C383.952 168.279 384.794 167.53 385.588 166.732H340.944C341.738 167.53 342.579 168.279 343.455 168.987Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M214.681 0.0566406V58.3705",
    stroke: "#D28E5A",
    strokeWidth: 2.4
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.776 64.2846C220.776 67.6596 218.047 70.3961 214.681 70.3961C211.314 70.3961 208.585 67.6596 208.585 64.2846C208.585 60.9084 211.314 58.1719 214.681 58.1719C218.047 58.1719 220.776 60.9084 220.776 64.2846Z",
    stroke: "#D28E5A",
    strokeWidth: 2.4
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.087 84.9795H223.274V68.6348H206.087V84.9795Z",
    fill: "#ECECEC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.003 119.09C242.003 144.544 218.631 165.179 214.681 165.179C210.731 165.179 187.359 144.544 187.359 119.09C187.359 93.6359 210.731 73 214.681 73C218.631 73 242.003 93.6359 242.003 119.09Z",
    fill: "#42C7A6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.117 119.736C233.117 118.032 228.517 116.57 221.952 115.938C226.076 111.186 228.489 107.437 227.717 106.664C226.946 105.891 223.208 108.31 218.469 112.445C217.838 105.862 216.38 101.25 214.681 101.25C212.982 101.25 211.525 105.862 210.893 112.445C206.154 108.31 202.415 105.891 201.644 106.664C200.873 107.437 203.286 111.186 207.409 115.938C200.844 116.57 196.245 118.032 196.245 119.736C196.245 121.44 200.844 122.901 207.409 123.534C203.286 128.286 200.873 132.035 201.644 132.808C202.415 133.581 206.154 131.162 210.893 127.027C211.524 133.61 212.982 138.222 214.681 138.222C216.38 138.222 217.838 133.61 218.469 127.027C223.208 131.162 226.946 133.581 227.717 132.808C228.489 132.035 226.076 128.286 221.952 123.534C228.517 122.902 233.117 121.44 233.117 119.736Z",
    fill: "#A1C2AA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0384 70.6955C57.0384 74.0705 54.3093 76.807 50.9422 76.807C47.5763 76.807 44.8472 74.0705 44.8472 70.6955C44.8472 67.3193 47.5763 64.584 50.9422 64.584C54.3093 64.584 57.0384 67.3193 57.0384 70.6955Z",
    stroke: "#D28E5A",
    strokeWidth: 2.4
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9433 0.0566406V64.9834",
    stroke: "#D28E5A",
    strokeWidth: 2.4
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3496 83.8203H59.5364V74.8027H42.3496V83.8203Z",
    fill: "#DBDBDB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5257 103.859C74.5257 116.918 63.9675 127.506 50.9429 127.506C37.9194 127.506 27.3613 116.918 27.3613 103.859C27.3613 90.8008 37.9194 80.2129 50.9429 80.2129C63.9675 80.2129 74.5257 90.8008 74.5257 103.859Z",
    fill: "#FF7052"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5739 90.9377C43.5739 92.211 42.5451 93.2426 41.2752 93.2426C40.0066 93.2426 38.9766 92.211 38.9766 90.9377C38.9766 89.6644 40.0066 88.6328 41.2752 88.6328C42.5451 88.6328 43.5739 89.6644 43.5739 90.9377Z",
    fill: "#FFD6CE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0634 119.893C57.0634 121.166 56.0346 122.196 54.7648 122.196C53.4961 122.196 52.4673 121.166 52.4673 119.893C52.4673 118.62 53.4961 117.588 54.7648 117.588C56.0346 117.588 57.0634 118.62 57.0634 119.893Z",
    fill: "#FFD6CE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0566 102.86C67.0566 104.133 66.0278 105.164 64.7579 105.164C63.4893 105.164 62.4604 104.133 62.4604 102.86C62.4604 101.586 63.4893 100.555 64.7579 100.555C66.0278 100.555 67.0566 101.586 67.0566 102.86Z",
    fill: "#FFD6CE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0576 86.4279C65.0576 87.7012 64.0288 88.7328 62.7601 88.7328C61.4903 88.7328 60.4614 87.7012 60.4614 86.4279C60.4614 85.1547 61.4903 84.123 62.7601 84.123C64.0288 84.123 65.0576 85.1547 65.0576 86.4279Z",
    fill: "#FFD6CE"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4648 103.461C55.4648 104.734 54.436 105.766 53.1673 105.766C51.8975 105.766 50.8687 104.734 50.8687 103.461C50.8687 102.188 51.8975 101.156 53.1673 101.156C54.436 101.156 55.4648 102.188 55.4648 103.461Z",
    fill: "#FFD6CE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2805 101.858C35.2805 103.131 34.2516 104.163 32.9818 104.163C31.7131 104.163 30.6831 103.131 30.6831 101.858C30.6831 100.584 31.7131 99.5527 32.9818 99.5527C34.2516 99.5527 35.2805 100.584 35.2805 101.858Z",
    fill: "#FFD6CE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2766 117.289C40.2766 118.563 39.2477 119.593 37.9779 119.593C36.7092 119.593 35.6792 118.563 35.6792 117.289C35.6792 116.016 36.7092 114.984 37.9779 114.984C39.2477 114.984 40.2766 116.016 40.2766 117.289Z",
    fill: "#FFD6CE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4726 108.471C44.4726 109.744 43.4438 110.775 42.1739 110.775C40.9053 110.775 39.8765 109.744 39.8765 108.471C39.8765 107.198 40.9053 106.166 42.1739 106.166C43.4438 106.166 44.4726 107.198 44.4726 108.471Z",
    fill: "#FFD6CE"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6528 116.285C67.6528 117.559 66.624 118.589 65.3553 118.589C64.0855 118.589 63.0566 117.559 63.0566 116.285C63.0566 115.012 64.0855 113.98 65.3553 113.98C66.624 113.98 67.6528 115.012 67.6528 116.285Z",
    fill: "#FFD6CE"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0498 105.065C74.0498 106.338 73.0209 107.37 71.7511 107.37C70.4824 107.37 69.4536 106.338 69.4536 105.065C69.4536 103.791 70.4824 102.76 71.7511 102.76C73.0209 102.76 74.0498 103.791 74.0498 105.065Z",
    fill: "#FFD6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupDecor);
export default __webpack_public_path__ + "static/media/popup-decor.830baf07d1fbe34aa268fb523f64ebb5.svg";
export { ForwardRef as ReactComponent };